import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { Avatar } from "@whoosh/design-system/src/components/display";
import { ArrowRightIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  Box,
  HStack,
  Text,
  Pressable,
} from "@whoosh/design-system/src/components/primitive";

import { MemberModalRow_Member$key } from "./__generated__/MemberModalRow_Member.graphql";

export const MemberModalRow = ({
  memberRef,
  onPress,
}: {
  memberRef: MemberModalRow_Member$key;
  onPress: (id: string) => void;
}) => {
  const member = useFragment(MemberModalRowfragmentString, memberRef);

  const fullName = `${member.firstName} ${member.lastName}`;
  return (
    <Pressable
      onPress={() => {
        onPress(member.id);
      }}
    >
      <HStack
        alignItems="center"
        py={5}
        style={{ borderBottomWidth: 1 }}
        borderBottomColor={"surface-dividers"}
      >
        <Avatar
          size="sm"
          profileImagePublicId={member.profileImage?.publicId}
          firstName={member.firstName}
          lastName={member.lastName}
        />
        <Box flex={1}>
          <Text ml={4} variant={"mainBaseMedium"}>
            {fullName}
          </Text>
        </Box>
        <Box>
          <ArrowRightIcon />
        </Box>
      </HStack>
    </Pressable>
  );
};

export const MemberModalRowfragmentString = graphql`
  fragment MemberModalRow_Member on Member {
    id
    firstName
    lastName
    profileImage {
      # TODO(ENG-3436): Remove the publicId alias when legacy image props are retired.
      publicId: renderingKey
    }
  }
`;
